export const SCORE_RANGES_REQUEST_PARAMS = {
  dimensions: [
    "test_view_score_ranges.rangeMin",
    "test_view_score_ranges.rangeMax",
    "test_view_score_ranges.metricType",
    "test_view_score_ranges.rangeSetId"
  ]
}

export enum SCORE_RANGES_TYPE {
  raw = "RAW",
  overall = "OVERALL",
  scaled = "SCALED"
}
